import * as React from 'react';
import * as Session from '../../service/Session';
import * as DTO from '../../service/DTOs';
import * as RB from 'react-bootstrap';
import * as TF from '../../service/tradeflow';
import * as Actions from '../../service/Actions';

import { ImpactorChat } from './ImpactorChat';
import { ImpactorNavigation } from './ImpactorNavigation';



type ImpactorChatProps = {
    syshdr: DTO.SystemHeader;
    user: Session.UserState,
    xsrfToken?: string,
    personalState?: Session.PersonalState,
    //idchat?: number,
    shareChatId?: number,
    appId: number,
    new_messages: DTO.AgentTextMessage[],
    chatactivity: DTO.AgentChatActivity[]
};

type ImpactorChatWidgetState = {
    idSelectedchat?: number,
    selectedChat?: DTO.ChatState
};

export class ImpactorChatWidget extends React.Component<ImpactorChatProps, ImpactorChatWidgetState> {

    constructor(props: ImpactorChatProps) {
        super(props);

        this.state = {
            ...{ idSelectedchat: props.shareChatId ? props.shareChatId : 0, selectedChat: undefined}
        };
    }

    componentDidMount() {
        TF.CommandProcessBinding(this, { type: 'COMMAND.SelectChat', delegate: this.processSelectChat });
    }

    componentWillUnmount() {
        TF.CommandProcessUnBinding(this, { type: 'COMMAND.SelectChat', delegate: this.processSelectChat });
    }

    ensureChat(chat: DTO.ChatState) {
        if (chat.privatechatuser) {
            Actions.chatActions.getOrCreateChat(this.props.user, chat.privatechatuser.personalState).then(x => {
                this.setState({ idSelectedchat: (x.chat ? x.chat.id : undefined) });
                const _chat: DTO.ChatState = {
                    ...chat,
                    privatechatuser: Object.assign({}, chat.privatechatuser)
                };

                this.setState({
                    selectedChat: x.chat ? _chat : undefined
                });
            }).catch(() => { this.setState({ idSelectedchat: undefined, selectedChat: undefined }); });
        }
        else {
            this.setState({ idSelectedchat: undefined, selectedChat: undefined  });
        }
    }

    processSelectChat = (cmd: TF.SelectChatCommand) => {
        //console.log('processSelectChat');
        //console.log(cmd.chat);

        if (cmd.chat.IdChat) {
            this.setState({ idSelectedchat: cmd.chat.IdChat });
            const chat: DTO.ChatState = {
                ...cmd.chat,
                privatechatuser: Object.assign({}, cmd.chat.privatechatuser)
            };

            this.setState({
                selectedChat: chat
            });
        }
        else {
            this.ensureChat(cmd.chat);
        }

        const chat: DTO.ChatState = {
            ...cmd.chat,
            privatechatuser: Object.assign({}, cmd.chat.privatechatuser)
        };

        this.setState({
            selectedChat: chat
        });

        return {};
    }

    //<ImpactorContacts {...this.props} />

    render() {
        let chatName = undefined;

        if (this.state.selectedChat && this.state.selectedChat.privatechatuser && this.state.selectedChat.privatechatuser.personalState)
            chatName = this.state.selectedChat.privatechatuser.personalState.lastName + ' ' + this.state.selectedChat.privatechatuser.personalState.firstName;
        else if (this.props.shareChatId == this.state.idSelectedchat)
            chatName = 'Общий чат';

        let lastact: (DTO.AgentChatActivity | undefined)= undefined;
        let cacts = this.props.chatactivity.filter(x => x.idchat == this.state.idSelectedchat);
        lastact = cacts.reduce((max, p) => p.lastmodify > max.lastmodify ? p : max, cacts[0]);

        return (
            <div>
                <RB.Row>
                    <RB.Col sm={4}>                        
                        <ImpactorNavigation {...this.props} /> 
                </RB.Col>
                    <RB.Col sm={8}>
                        <div className="otc-panel-impactor-hdr2">{chatName}</div>
                        <div>Сообщения</div>
                        <ImpactorChat {...this.props} idchat={this.state.idSelectedchat} new_chat_messages={this.props.new_messages.filter(x => x.idchat == this.state.idSelectedchat)} lastactiv={lastact} />
                </RB.Col>
            </RB.Row>
        </div>
        );
    }
}